import { Grid2 } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AccountAverageRateBlock, AccountDiscoveryRate, GapsBlock } from "..";
import { CustomLoader } from "../../../ui/CustomLoader";
import { CustomToast } from "../../../ui/CustomToast";
import { ButtonTabs } from "../../../ui";
import { useGetCampaignDetailsQuery } from "../../../../api";

const tabs = ["Buying Committee", "Buying Cluster"];
const initialTab = tabs[0];

export const AccountAnalyticBlock = () => {
  const { account_id } = useParams();
  const [currentTab, setCurrentTab] = useState(initialTab);

  const { data, isLoading, isError } = useGetCampaignDetailsQuery({
    account_id: account_id!,
  });

  useEffect(() => {
    if (isError) {
      toast.error(
        <CustomToast
          type="error"
          text={"Detailed BC analysis upload Failed"}
          title="Upload Failed"
        />,
      );
    }
  }, [isError]);

  if (isLoading || !data) return <CustomLoader />;

  const {
    is_analyzed,
    output: {
      summary: {
        total: { original, enriched },
        expected,
        percentage,
        title_gaps,
      },
    },
  } = data;

  const graphsProps =
    currentTab === initialTab
      ? {
          currentSize: original.committee_members + enriched.committee_members,
          expectedSize: expected.committee_members,
          original: percentage.committee.original,
          original_indicator: percentage.committee.original_indicator,
          original_change: percentage.committee.original_change,
          original_changed_at: percentage.committee.original_changed_at,
          enriched: percentage.committee.enriched,
          enriched_indicator: percentage.committee.enriched_indicator,
          enriched_change: percentage.committee.enriched_change,
          enriched_changed_at: percentage.committee.enriched_changed_at,
        }
      : {
          currentSize: original.cluster_members + enriched.cluster_members,
          expectedSize: expected.cluster_members,
          original: percentage.cluster.original,
          original_indicator: percentage.cluster.original_indicator,
          original_change: percentage.cluster.original_change,
          original_changed_at: percentage.cluster.original_changed_at,
          enriched: percentage.cluster.enriched,
          enriched_indicator: percentage.cluster.enriched_indicator,
          enriched_change: percentage.cluster.enriched_change,
          enriched_changed_at: percentage.cluster.enriched_changed_at,
        };

  const {
    engagement: { score, indicator, change, changed_at },
  } = percentage;
  return (
    <Grid2 container spacing={3}>
      <Grid2 size={{ xs: 12, md: 5.6 }} sx={{ display: "flex" }}>
        <AccountDiscoveryRate currentTab={currentTab} {...graphsProps}>
          <ButtonTabs
            currentTab={currentTab}
            onChange={setCurrentTab}
            tabList={tabs}
          />
        </AccountDiscoveryRate>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 4.2 }} sx={{ display: "flex" }}>
        <GapsBlock
          titleGaps={title_gaps}
          isRoleChartBtnDisabled={!is_analyzed}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 2.2 }} sx={{ display: "flex" }}>
        <AccountAverageRateBlock
          value={score || 0}
          indicator={indicator}
          indicatorChange={change}
          indicatorChangeAt={changed_at}
        />
      </Grid2>
    </Grid2>
  );
};
